/**
 * FERP Portal - Integration List Page (DRR-074: Tabulator DRY Template)
 *
 * OPTIMIZE Phase: External system connections with health monitoring.
 * Delegates to TabulatorPrimitiveManager for consistent CRUD across all 25 primitives.
 */

import { TabulatorPrimitiveManager } from '@/components/primitives/TabulatorPrimitiveManager';

export function IntegrationListPage() {
  return <TabulatorPrimitiveManager primitiveType="integration" />;
}

export default IntegrationListPage;
